import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
export var getThemeOverridePreferences = function getThemeOverridePreferences(_themeState) {
  var themeOverridePreferences = [];
  return _toConsumableArray(new Set(themeOverridePreferences));
};